import { Provider } from 'react-redux';
import store, { persistor } from './store';
import { PortalProvider, Portal } from '@rmwc/base';
import FormContainer from './components/Form/FormContainer';
import { createRoot } from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';
import Loader from './components/Loader/Loader';

export default function (el, type) {
  const formAction = el.getAttribute('data-action');
  let formIntro = el.getAttribute('data-form-intro') ?? '';
  if (formIntro) {
    formIntro = JSON.parse(formIntro);
  } else {
    formIntro = {};
  }

  const root = createRoot(el);

  root.render(
    <Provider store={store}>
      <PersistGate loading={<Loader />} persistor={persistor}>
        <PortalProvider>
          <FormContainer
            action={formAction}
            formType={type}
            formIntro={formIntro}
          />
        </PortalProvider>
        <Portal />
      </PersistGate>
    </Provider>
  );
}
